export const Images = {
  ON_ACCOUNT_BALANCE: 'wallet',
  AMWAY_POINTS: 'money-bills-simple',
  CREDIT_VOUCHER: 'money-check-dollar',
  INSTALLMENT_PAYMENT: 'calendar-check',
  IPP_NO_PLANS: '/images/checkoutNoStoreError.svg',
  DIRECT_DEBIT_BANKING: 'money-bill-transfer',
  CASH: 'money-bill-1-wave',
  QR_CODE: 'money-bill-1-wave',
  CREDIT_DEBIT_CARD: 'credit-card',
  PAY_LATER_QR: 'money-bill-1-wave',
  ONLINE_BANKING: 'university',
  PAY_NEW_CARD: '/icons/payment-new-card-selected.svg',
  PAY_NEW_CARD_UNSELECTED: '/icons/payment-new-card-unselected.svg',
  PAY_LATER_CASH: '/icons/efecty.svg',
};

export const methodLabels = {
  ON_ACCOUNT_BALANCE: 'payment.paymentMethods.ON_ACCOUNT_BALANCE',
  CREDIT_VOUCHER: 'payment.paymentMethods.CREDIT_VOUCHER',
  AMWAY_POINTS: 'payment.paymentMethods.AMWAY_POINTS',
  CREDIT_DEBIT_CARD: 'payment.paymentMethods.CREDIT_DEBIT_CARD',
  QR_CODE: 'payment.paymentMethods.QR_CODE',
  INSTALLMENT_PAYMENT: 'payment.paymentMethods.INSTALLMENT_PAYMENT',
  PAY_LATER_QR: 'payment.paymentMethods.PAY_LATER_QR',
  ONLINE_BANKING: 'payment.paymentMethods.ONLINE_BANKING',
  TH_PAY_LATER_CNB: 'payment.paymentMethods.TH_PAY_LATER_CNB',
  PAY_LATER_CASH: 'payment.paymentMethods.PAY_LATER_CASH',
  PAY_AT_SHOP: 'payment.paymentMethods.PAY_AT_SHOP',
};

export const paymentRoutes = {
  PAYMENT_SUCCESS: '/order/{id}',
  CHECKOUT_RETRY: '/checkout-retry/{orderId}',
};
